





































































/** @format */

import { Component, Mixins, Watch } from 'vue-property-decorator';
import TableMixin from '@root/common/mixins/table';
import TableWidthMixin from '@root/common/mixins/table-width';
// import moment from 'moment'
// import { DEFAULT_DATE_FORMAT } from '@root/common/config'
import { DEVICE_LIST } from '../router-names';
// import { debounce } from 'lodash'
import * as _ from 'lodash';
// 下拉框组件
import ParkingLotSearch from '../../../components/parking-lot-search/index.vue';
// 设备表单组件
import AddDeviceForm from './components/add-device-form.vue';
// axios请求
import { addOrEditDeviceList, deleteDeviceList } from '@/api/parking-lot-management/index';
import Utils from '@root/utils/common';
// 字典组件
import { dictAlonePayMap, dictDeviceTypeMap, dictBrandMap } from '@/types/parking-lot-management/dictionaries';
import { Mutation } from 'vuex-class';
import { CLOSE_CURRENT_TAB } from '@/store/mutation-types';
@Component({
  components: { AddDeviceForm }
})
// @Component
export default class DeviceListCreate extends Mixins(TableMixin, TableWidthMixin) {
  @Mutation(`pageTabs/${CLOSE_CURRENT_TAB}`)
  closeCurrentTab!: Function;
  path = '/smart-parking/parking-lot-management/device-list/';
  queryAreaListDebounce: any = function() {}; // 列表防抖请求
  deviceId: string = ''; //设备id
  tableData: any[] = []; // 表数据
  formData = {}; //添加通道表单
  // isshow: boolean = true
  isEdit: boolean = false;
  showDevFlag: boolean = true;
  headTitle = '添加设备';

  // 面包屑数据
  get breadcrumbNav() {
    return [
      {
        label: '设备信息',
        location: {
          name: DEVICE_LIST
        }
      },
      {
        label: this.headTitle
      }
    ];
  }
  // 表字段说明
  get tableColums() {
    return [
      {
        title: '序号',
        width: 60,
        customRender: (text: any, record: any, index: number) => `${(this.current - 1) * this.pageSize + index + 1}`
      },
      {
        title: '设备名称',
        dataIndex: 'name',
        width: 200,
        scopedSlots: { customRender: 'text-ellipse-18' }
      },
      {
        title: '所属车场',
        dataIndex: 'parkName',
        width: 170,
        scopedSlots: { customRender: 'text-ellipse-14' }
      },
      {
        title: '设备类型',
        dataIndex: 'typeDesc',
        width: 120,
        scopedSlots: { customRender: 'text-ellipse' }
      },
      {
        title: '设备品牌',
        dataIndex: 'brandDesc',
        width: 120,
        scopedSlots: { customRender: 'text-ellipse-10' }
      },
      {
        title: '设备IP',
        dataIndex: 'ip',
        width: 120,
        scopedSlots: { customRender: 'text-ellipse-10' }
      },
      {
        title: '设备端口',
        dataIndex: 'port',
        width: 120,
        scopedSlots: { customRender: 'text-ellipse-10' }
      },
      {
        title: '设备优先级',
        dataIndex: 'priority',
        width: 110
      },
      {
        title: '操作',
        dataIndex: 'operator',
        width: 120,
        scopedSlots: { customRender: 'operation' }
      }
    ];
  }
  // 生命周期初始化
  created() {
    // this.queryAddOrEditDeviceList()
  }
  // 添加按钮事件
  isshowDev() {
    this.showDevFlag = true;
    this.isEdit = false;
  }
  isCloseDev() {
    this.showDevFlag = false;
    this.goBack();
  }
  // 删除项
  async toDelete(row: any) {
    const { deviceId, parkId } = row;
    try {
      const { status, data, code, msg } = await deleteDeviceList({
        deviceId,
        parkId
      });
      if (status === '9999') {
        this.$message.success('删除成功');
        // 删除成功更新
        const index = this.tableData.findIndex(item => item.deviceId === deviceId);
        if (index > -1) {
          this.tableData.splice(index, 1);
        }
      } else {
        this.$message.error(msg);
      }

      // this.tableData.filter(item => item.deviceId !== deviceId)
    } catch (e) {
      this.$message.error('删除失败');
    }
  }

  toUpdate(dataForm: any) {
    this.showDevFlag = true;
    this.isEdit = true;
    this.formData = { ...dataForm, deviceId: this.deviceId };
  }
  // 点击保存
  isSubmitOk(values: any) {
    this.deviceId = values.deviceId;
    this.showDevFlag = false;
    if (this.isEdit) {
      // 编辑成功更新
      const index = this.tableData.findIndex(item => item.deviceId === values.deviceId);
      if (index > -1) {
        this.tableData.splice(index, 1, values);
      }
      // this.isEdit = false
    } else {
      // 新增成功更新
      this.tableData.push(values);
    }
  }

  // 返回
  goBack() {
    // 清除当前tab页签
    this.closeCurrentTab();
    this.$router.replace({
      name: DEVICE_LIST
    });
  }
}
